// src/Pages/Selections/ViewSelection.jsx
import React from "react";
import { FaUser, FaCalendar, FaPhone, FaEnvelope, FaMapMarker, FaTrophy, FaBriefcase } from "react-icons/fa";

function ViewSelection({ data }) {
  if (!data) {
    return <div className="text-center py-4">No data available</div>;
  }

  const isActive = (status) => status === 1 || status === "1";

  const getTypeLabel = (type) => {
    return type === "sports" ? "Sports" : "Government Job";
  };

  return (
    <div className="custom-modal-body">
      <div className="model-custum">
        <div className="text-center mb-4">
          {data.image ? (
            <img
              src={data.image_url || `${process.env.REACT_APP_API_URL}/uploads/selections/${data.image}`}
              alt={data.member_name}
              style={{
                width: "120px",
                height: "120px",
                objectFit: "cover",
                borderRadius: "50%",
                border: "4px solid #0d6efd",
              }}
            />
          ) : (
            <div
              style={{
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                background: "#e9ecef",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto",
                fontSize: "48px",
                color: "#6c757d",
              }}
            >
              <FaUser />
            </div>
          )}
          <h4 className="mt-3 mb-0">{data.member_name}</h4>
          <span className={`badge ${data.type === 'sports' ? 'bg-success' : 'bg-primary'}`}>
            {getTypeLabel(data.type)}
          </span>
          <span className={`badge ms-2 ${isActive(data.status) ? 'bg-success' : 'bg-danger'}`}>
            {isActive(data.status) ? 'Active' : 'Inactive'}
          </span>
        </div>

        <div className="view-details-grid">
          {/* Personal Information */}
          <div className="view-section">
            <h6 className="fw-semibold text-primary mb-3">
              <FaUser className="me-2" /> Personal Information
            </h6>
            <div className="row">
              <div className="col-md-6">
                <div className="view-detail-card">
                  <span>Member Name</span>
                  <h5>{data.member_name || "N/A"}</h5>
                </div>
              </div>
              <div className="col-md-6">
                <div className="view-detail-card">
                  <span>Father Name</span>
                  <h5>{data.father_name || "N/A"}</h5>
                </div>
              </div>
              <div className="col-md-6">
                <div className="view-detail-card">
                  <span>Mother Name</span>
                  <h5>{data.mother_name || "N/A"}</h5>
                </div>
              </div>
              <div className="col-md-6">
                <div className="view-detail-card">
                  <span>Gender</span>
                  <h5>{data.gender ? data.gender.charAt(0).toUpperCase() + data.gender.slice(1) : "N/A"}</h5>
                </div>
              </div>
              <div className="col-md-6">
                <div className="view-detail-card">
                  <span>Date of Birth</span>
                  <h5>{data.date_of_birth ? new Date(data.date_of_birth).toLocaleDateString() : "N/A"}</h5>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="view-section mt-3">
            <h6 className="fw-semibold text-primary mb-3">
              <FaPhone className="me-2" /> Contact Information
            </h6>
            <div className="row">
              <div className="col-md-6">
                <div className="view-detail-card">
                  <span>Mobile</span>
                  <h5>{data.mobile || "N/A"}</h5>
                </div>
              </div>
              <div className="col-md-6">
                <div className="view-detail-card">
                  <span>Email</span>
                  <h5>{data.email || "N/A"}</h5>
                </div>
              </div>
              <div className="col-md-12">
                <div className="view-detail-card">
                  <span>Address</span>
                  <h5>{data.address || "N/A"}</h5>
                </div>
              </div>
              <div className="col-md-6">
                <div className="view-detail-card">
                  <span>Waad</span>
                  <h5>{data.waad_name || "N/A"}</h5>
                </div>
              </div>
            </div>
          </div>

          {/* Sports Information */}
          {data.type === "sports" && (
            <div className="view-section mt-3">
              <h6 className="fw-semibold text-success mb-3">
                <FaTrophy className="me-2" /> Sports Information
              </h6>
              <div className="row">
                <div className="col-md-6">
                  <div className="view-detail-card">
                    <span>Sport Name</span>
                    <h5>{data.sport_name || "N/A"}</h5>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="view-detail-card">
                    <span>Sport Category</span>
                    <h5>{data.sport_category || "N/A"}</h5>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="view-detail-card">
                    <span>Sport Level</span>
                    <h5>{data.sport_level || "N/A"}</h5>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="view-detail-card">
                    <span>Achievement</span>
                    <h5>{data.achievement || "N/A"}</h5>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="view-detail-card">
                    <span>Selection Date</span>
                    <h5>{data.selection_date ? new Date(data.selection_date).toLocaleDateString() : "N/A"}</h5>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Government Job Information */}
          {data.type === "govt_job" && (
            <div className="view-section mt-3">
              <h6 className="fw-semibold text-primary mb-3">
                <FaBriefcase className="me-2" /> Government Job Information
              </h6>
              <div className="row">
                <div className="col-md-6">
                  <div className="view-detail-card">
                    <span>Job Type</span>
                    <h5>{data.job_type || "N/A"}</h5>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="view-detail-card">
                    <span>Job Department</span>
                    <h5>{data.job_department || "N/A"}</h5>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="view-detail-card">
                    <span>Job Designation</span>
                    <h5>{data.job_designation || "N/A"}</h5>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="view-detail-card">
                    <span>Job Level</span>
                    <h5>{data.job_level || "N/A"}</h5>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="view-detail-card">
                    <span>Selection Date</span>
                    <h5>{data.selection_date ? new Date(data.selection_date).toLocaleDateString() : "N/A"}</h5>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="view-detail-card">
                    <span>Joining Date</span>
                    <h5>{data.joining_date ? new Date(data.joining_date).toLocaleDateString() : "N/A"}</h5>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* System Information */}
          <div className="view-section mt-3">
            <h6 className="fw-semibold text-secondary mb-3">
              <FaCalendar className="me-2" /> System Information
            </h6>
            <div className="row">
              <div className="col-md-6">
                <div className="view-detail-card">
                  <span>Created At</span>
                  <h5>{data.created_at ? new Date(data.created_at).toLocaleString() : "N/A"}</h5>
                </div>
              </div>
              <div className="col-md-6">
                <div className="view-detail-card">
                  <span>Updated At</span>
                  <h5>{data.updated_at ? new Date(data.updated_at).toLocaleString() : "N/A"}</h5>
                </div>
              </div>
              <div className="col-md-6">
                <div className="view-detail-card">
                  <span>Admin</span>
                  <h5>{data.admin_name || "N/A"}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewSelection;